import Vue from 'vue'
import Vuetify from 'vuetify'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import Meta from 'vue-meta'

Vue.config.productionTip = false

Vue.use(Meta)

Vue.use(Vuetify, {
  theme: {
    primary: '#607D8B',
    secondary: '#0D47A1'
  }
})

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
